import script from "./TopicCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicCard.vue?vue&type=script&setup=true&lang=js"

import "./TopicCard.vue?vue&type=style&index=0&id=e1004636&lang=scss"

const __exports__ = script;

export default __exports__